import React from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./scss/style.css";
import "./styles/tokens.css";
import { SWRConfig } from "swr";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from "react-router-dom";
import routes from "./routes";
import { AuthContext, ZAuth } from "./auth/ZAuth";
import Landing from "./pages/landing/Landing";
import Login from "./pages/auth/Login";
import Signup from "./pages/auth/Signup";
import Forgot from "./pages/auth/Forgot";
import Confirmation from "./pages/debt/Confirmation";
import PartyShare from "./pages/debt/PartyShare";
import Viewer from "./pages/share/Viewer";
import axiosInstance from "./api/axiosInstance";

const fetcher = (u) => axiosInstance.get(u).then((r) => r.data);

const Main = (props) => {
  const { user } = React.useContext(AuthContext);
  if (user === null) return <div />;
  if (user === undefined) return <Redirect to="/login" />;
  return (
    <>
      {routes.map((r, i) => (
        <Route key={i} path={r.to} exact={r.exact} component={r.component} />
      ))}
    </>
  );
};

function App() {
  return (
    <SWRConfig value={{ fetcher, revalidateOnFocus: false }}>
      <Router>
        <ZAuth>
          <Switch>
            <Route path="/landing" exact component={Landing} />
            <Route path="/login" exact component={Login} />
            <Route path="/signup" exact component={Signup} />
            <Route path="/signup/confirm" exact component={Signup} />
            <Route path="/forgot" exact component={Forgot} />
            <Route
              path="/konfirmasi/:token"
              exact
              component={Confirmation}
            />
            <Route
              path="/share/party/:token"
              exact
              component={PartyShare}
            />
            <Route path="/share/:token" exact component={Viewer} />
            <Route path="/" component={Main} />
            <Redirect to="/landing" />
          </Switch>
        </ZAuth>
        <ToastContainer />
      </Router>
    </SWRConfig>
  );
}

export default App;
